import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  FaUserCircle,
  FaCog,
  FaSignOutAlt,
  FaSearch,
  FaBell,
  FaBars,
  FaUserShield,
} from "react-icons/fa";
import "./header.css";

export const Header = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) navigate("/admin-login", { replace: true });
  }, [navigate]);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      sessionStorage.clear();
      navigate("/admin-login", { replace: true });
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar navbar-expand-lg premium-header fixed-top shadow-sm px-4">
      <div className="container-fluid p-0">
        {/* LEFT: Menu Toggle & Brand */}
        <div className="d-flex align-items-center">
          <button
            className="btn border-0 p-2 me-2 d-lg-none text-white shadow-none"
            id="sidebarToggle"
          >
            <FaBars size={20} />
          </button>
          <Link
            to="/dashboard"
            className="navbar-brand d-flex align-items-center gap-2 m-0 text-white"
          >
            {/* <div className="brand-logo-bg">⚖️</div> */}
            <span className="brand-name fw-bold d-none d-sm-inline">
              VishnuJI Maharaj
            </span>
          </Link>
        </div>

        {/* CENTER: Premium Search Bar */}
        <div className="header-search-container d-none d-md-flex mx-auto">
          <div className="search-pill">
            <FaSearch className="search-icon-muted" />
            <input
              type="text"
              placeholder="Search for users, IDs or queries..."
              className="search-input-field"
            />
          </div>
        </div>

        {/* RIGHT: Action Icons & User Profile */}
        <div className="d-flex align-items-center gap-3">
          {/* Notification Icon */}
          {/* <button className="notification-btn position-relative">
            <FaBell size={20} />
            <span className="pulse-badge">3</span>
          </button> */}

          {/* User Profile Dropdown */}
          <div className="position-relative" ref={dropdownRef}>
            <button
              className="user-profile-btn d-flex align-items-center gap-2"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <div className="avatar-wrapper">
                <FaUserShield size={22} className="text-white" />
              </div>
              <div className="d-none d-lg-block text-start text-white ms-1">
                <p className="user-name-header m-0">Admin</p>
                <p className="user-role-header m-0 opacity-75">Super Admin</p>
              </div>
              <span
                className={`dropdown-arrow-icon ${dropdownOpen ? "rotate" : ""}`}
              >
                ▼
              </span>
            </button>

            {/* Premium Dropdown Menu */}
            {dropdownOpen && (
              <div className="premium-dropdown-menu animate-slide-up shadow-lg border-0 rounded-4">
                <div className="dropdown-info-header px-4 py-3 bg-light">
                  <p className="fw-bold m-0 text-dark">Welcome, Admin</p>
                  <small className="text-muted truncate">
                    admin@advmatrimony.com
                  </small>
                </div>

                <div className="p-2">
                  {/* <Link to="/profile" className="dropdown-item-custom">
                    <FaUserCircle className="icon-blue" />{" "}
                    <span>My Profile</span>
                  </Link>
                  <Link to="/settings" className="dropdown-item-custom">
                    <FaCog className="icon-grey" /> <span>Settings</span>
                  </Link> */}
                  <div className="dropdown-divider mx-2"></div>
                  <button
                    onClick={handleLogout}
                    className="dropdown-item-custom text-danger border-0 bg-transparent w-100"
                  >
                    <FaSignOutAlt /> <span className="fw-bold">Logout</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
